'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const PriceBarQuantityLabel = renderWithRef('PriceBarQuantityLabel', null, (t, a)=>{
    let o = new Set([
        'swan-price-bar-button-label'
    ]), { children: n } = t;
    return jsx(RenderComp, {
        root: "span",
        forwardedRef: a,
        classNames: o,
        props: t,
        children: n
    });
});

export { PriceBarQuantityLabel };
